import { useContext } from 'react'

import { NicheScopeContext } from './niche-scope.context'
import type { TUseNicheScopeReturn } from './niche-scope.types'

/**
 * Reads the current Promoted-Niche scope from the nearest `NicheScopeProvider`.
 *
 * The provider is mounted once at the top of the scoped Niche Territory route,
 * so descendants — including components rendered inside `TerritoryPage`'s
 * concrete-path nested tab `<Route>`s, where `useParams` no longer exposes
 * `:categoryId` — read a stable scope value. When no provider is mounted
 * (legacy `/niche/:id` and all unscoped routes) every field is `null`/`false`
 * and consumers degrade to today's unscoped behaviour without throwing.
 */
export const useNicheScope = (): TUseNicheScopeReturn => useContext(NicheScopeContext)
